<script setup lang="ts">
import type { OrderInvoiceFile } from '../../model/invoice/interfaces'

import { faArrowDownToLine, faFileLines } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'
import { AppText } from '@shared/ui/typography'
import { BtnIcon } from '@shared/ui/buttons'

defineOptions({
  name: 'OrderInvoiceFiles',
})

defineProps<{
  invoices: OrderInvoiceFile[]
  disabled: boolean
}>()

defineEmits<{
  'click:download': [invoice: OrderInvoiceFile]
}>()
</script>

<template>
  <div class="order-invoice-files">
    <AppText name="body1-medium">
      Generated invoices
    </AppText>
    <ul
      v-if="invoices.length"
      class="order-invoice-files__list"
    >
      <li
        v-for="invoice in invoices"
        :key="invoice.id"
        class="order-invoice-files__row"
      >
        <AppIcon
          :icon="faFileLines"
          color="slate-500"
          size="small"
        />
        <button
          type="button"
          class="order-invoice-files__name"
          :disabled="disabled"
          @click="$emit('click:download', invoice)"
        >
          <AppText
            name="body2"
            tag="span"
            text-decoration="underline"
          >
            {{ invoice.filename }}
          </AppText>
        </button>
        <BtnIcon
          :icon="faArrowDownToLine"
          color="blue"
          view="transparent"
          size="small"
          :title="`Download ${invoice.filename}`"
          :disabled="disabled"
          @click="$emit('click:download', invoice)"
        />
      </li>
    </ul>
    <AppText
      v-else
      name="body2"
      color="slate-500"
    >
      No saved invoices yet
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./OrderInvoiceFiles.scss" />
